module.exports = __webpack_public_path__ + "images/Silk_Road-265348.png";